import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { ICommandStatus } from '@cqrs/cqrs';
import { ICommandBase } from '@Quest/cqrs';
import { TriggerMetricUpdatesCommandV1 } from '@Quest/Strategies/Domain/commands-core';
import StrategiesCommands from '@Quest/Strategies/Domain/commands-vue-component';
import StrategiesQueries from '@Quest/Strategies/Domain/queries-vue-component';
import { StrategyFixPageReadModel } from '@Quest/Strategies/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';

@Component({ components: { CorporateNavigation } })
export default class StrategyFixPage extends mixins(StrategiesQueries, StrategiesCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: StrategyFixPageReadModel | null = null;
    isBusy: boolean = false;

    mounted()
    {
        document.title = "Enterprise Fix | TransparentChoice";
        this.runStrategyFixPageQueryV1(this.workspaceId, this.strategyId);
    }

    handleTriggerMetricUpdatesCommand()
    {
        this.isBusy = true;
        this.invokeTriggerMetricUpdatesCommandV1(this.workspaceId, this.strategyId);
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "StrategyFixPageReadModel")
        {
            this.rm = model as StrategyFixPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (TriggerMetricUpdatesCommandV1.matchType(cmd))
        {
            this.isBusy = false;
            alert('Done');
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (TriggerMetricUpdatesCommandV1.matchType(status.Command))
        {
            this.isBusy = false;
            alert(status.Error);
        }
    }
}